import { css } from '@emotion/react'
import { motion } from 'motion/react'
import type { InputHTMLAttributes } from 'react'

export interface ToggleProps extends InputHTMLAttributes<HTMLInputElement> {}

export default function Toggle({ checked, onChange, ...props }: ToggleProps) {
	return (
		<label
			css={css`
				display: inline-block;
				width: 57px;
				height: 30px;
				position: relative;
				cursor: pointer;
			`}
		>
			<input
				type="checkbox"
				css={css`
					opacity: 0;
					width: 0;
					height: 0;
				`}
				onChange={onChange}
			/>
			<motion.span
				animate={{
					backgroundColor: checked ? 'var(--bg-jike-yellow)' : 'var(--bg-on-body-2)',
				}}
				transition={{ duration: 0.3 }}
				css={css`
					position: absolute;
					cursor: pointer;
					inset: 0;
					border-radius: 100px;
				`}
			/>
			<motion.span
				animate={{
					x: checked ? 27 : 0,
				}}
				transition={{
					type: 'spring',
					stiffness: 500,
					damping: 30,
				}}
				css={css`
					position: absolute;
					content: '';
					height: 24px;
					width: 24px;
					left: 3px;
					bottom: 3px;
					background-color: var(--bg-body-1);
					border-radius: 50%;
					box-shadow: 0 2px 4px rgb(0 0 0 / 15%);
				`}
			/>
		</label>
	)
}
